"use client";

import * as React from "react";
import { Toaster as SonnerToaster, type ToasterProps } from "sonner";

/**
 * Pre-configured Sonner toast container.
 *
 * Render once at the root of your application (e.g. in a layout component).
 * All props are forwarded to Sonner's `<Toaster>` — override position,
 * theme, styling, etc. as needed per-app.
 */
const Toaster = (props: ToasterProps) => (
	<SonnerToaster richColors {...props} />
);

export { Toaster, type ToasterProps };
